import {
  createV1Color,
  fetchV1Colors,
  searchV1Colors,
} from "@/services/v1/inventoryAPIService";

export default {
  state: {
    colors: [],
    colorPageSize: 5,
    totalColorCount: 0,
    colorSearchQuery: '',
  },
  getters: {
    colors: (state) => state.colors,
    currentColorPageSize: (state) => state.colorPageSize,
    totalColorCount: (state) => state.totalColorCount,
  },
  mutations: {
    SET_COLORS(state, colors) {
      state.colors = colors;
    },
    SET_COLOR_PAGE_SIZE(state, pageSize) {
      state.colorPageSize = pageSize;
    },
    SET_TOTAL_COLORS_COUNT(state, count) {
      state.totalColorCount = count;
    },
    SET_COLOR_SEARCH_QUERY(state, query) {
      state.colorSearchQuery = query;
    }
  },
  actions: {
    async fetchColors({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Colors(page, pageSize);
        commit("SET_COLORS", response.results);
        commit("SET_COLOR_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_COLORS_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching colors:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async searchColors({ commit }, { query, page = 1, pageSize = 8 } = {}) {
      commit("SET_COLOR_SEARCH_QUERY", query);
      try {
        const response = await searchV1Colors(query, page, pageSize);
        commit("SET_COLORS", response.results);
        commit("SET_COLOR_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_COLORS_COUNT", response.count);
      } catch (error) {
        console.error("Error searching colors:", error);
      }
    },
    async addColor({ commit }, color) {
      try {
        const response = await createV1Color(color);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`color create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message = error.response?.data?.message || "Failed to add Color.";
        return { success: false, message };
      }
    },
  },
};
